// file where you pass in values, update the design website // 

export const homeObjOne = {
    id: 'about',
    lightBg: false,
    lightText: true,
    lightTextDesc: true,
    topLine: 'A Market For All Women Across Africa',
    headline: 'Closing the digital information gap for women in trade',
    description: "African Marketplace empowers women-led small and medium-sized enterprises to trade to legally, safely, and profitabling across Africa's borders.",
    buttonLabel: 'Get Started',
    imgStart: false,
    img: require('../../images/img1.jpg').default,
    alt: 'women walking in a market',
    dark: true,
    primary: true,
    darkText: false
};
export const homeObjTwo = {
    id: 'services',
    lightBg: true,
    lightText: false,
    lightTextDesc: false,
    topLine: 'Our Services',
    headline: 'Technology Solution coupled with Research and Evidence',
    description: "We combine innovative technologies with proven deep expertise to empower women as forces of change in markets, communities, and households.",
    buttonLabel: 'Learn More',
    imgStart: true,
    img: require('../../images/img3.jpg').default,
    alt: 'women working in a farm',
    dark: false,
    primary: false,
    darkText: true
};

export const homeObjThree = {
    id: 'products',
    lightBg: false,
    lightText: true,
    lightTextDesc: true,
    topLine: 'Our Products',
    headline: 'Bring Things to Make and Sell',
    description: "We have wholesale and retail price information available for 110 products and 77 markets in 8 East African countries.",
    buttonLabel: 'Add Products',
    imgStart: false,
    img: require('../../images/img5.jpg').default,
    alt: 'women selling in a market',
    dark: true,
    primary: true,
    darkText: false
};

export const homeObjFour = {
    id: 'signup',
    lightBg: true,
    lightText: false,
    lightTextDesc: false,
    topLine: 'Join Our Team',
    headline: 'Creating an account is extremely easy',
    description: "Get everything set up and ready in under 10 minutes. All you need to do is add your information and you're ready to go.",
    buttonLabel: 'Start Now',
    imgStart: true,
    img: require('../../images/img6.jpg').default,
    alt: 'a group of women',
    dark: false,
    primary: false,
    darkText: true
};


export const homeObjFive = {
    id: 'signup',
    lightBg: true,
    lightText: false,
    lightTextDesc: false,
    topLine: 'Join Our Team',
    headline: 'Creating an account is extremely easy',
    description: "Get everything set up and ready in under 10 minutes. All you need to do is add your information and you're ready to go.",
    buttonLabel: 'Start Now',
    imgStart: true,
    img: require('../../images/img6.jpg').default,
    alt: 'a group of women',
    dark: false,
    primary: false,
    darkText: true
};
